import { NavLink, Navigate, Outlet } from "react-router-dom";
import { LogOut, Table2, Users, Settings as Cog, Loader2, Printer } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/entries", label: "Entries", icon: Table2, id: "nav-entries" },
  { to: "/reports/group", label: "Group Report", icon: Users, id: "nav-group" },
  { to: "/printables", label: "Printables", icon: Printer, id: "nav-printables" },
  { to: "/settings", label: "GHL Settings", icon: Cog, id: "nav-settings" },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  if (user === null)
    return (
      <div className="grid min-h-screen place-items-center">
        <Loader2 className="h-6 w-6 animate-spin text-[#1F4266]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen">
      <header className="no-print sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center gap-6 px-4 sm:px-8 h-16">
          <div className="flex items-center gap-2.5">
            <img src="/flower-logo.png" alt="" className="h-8 w-8" />
            <span className="font-display text-lg font-bold text-[#1F4266] hidden sm:inline">Assessment Reports</span>
          </div>
          <nav className="flex items-center gap-1 overflow-x-auto">
            {links.map(({ to, label, icon: Icon, id }) => (
              <NavLink
                key={to}
                to={to}
                data-testid={id}
                className={({ isActive }) =>
                  `flex items-center gap-2 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive ? "bg-[#1F4266] text-white" : "text-slate-600 hover:bg-slate-100"
                  }`
                }
              >
                <Icon className="h-4 w-4" /> <span className="hidden md:inline">{label}</span>
              </NavLink>
            ))}
          </nav>
          <button
            data-testid="logout-button"
            onClick={logout}
            className="ml-auto flex items-center gap-2 rounded-full px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 sm:px-8 py-8 sm:py-12 print-plain">
        <Outlet />
      </main>
    </div>
  );
};
